import { render, staticRenderFns } from "./WorkerTab.vue?vue&type=template&id=80d80b74"
import script from "./WorkerTab.vue?vue&type=script&lang=js"
export * from "./WorkerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports